import type { ProjectScope } from '../sync/project-scope.ts';
import {
    enqueueStructuredEntityWrite,
    type StructuredEntityWriteRegistration,
} from '../sync/structured-entity-write.ts';

type PropWriteOptions = {
    actorId?: string;
};

const PROP_WRITE_REGISTRATION: StructuredEntityWriteRegistration = {
    feature: 'department_tracking',
    capability: 'EDIT_PROPS',
    conflictPrefix: 'props',
    allowedKinds: ['patchEntity', 'deleteEntity'],
    authErrorMessage: 'Authentication required to preserve prop project writes',
};

export async function deleteProp(
    scope: ProjectScope,
    propId: string,
    options: PropWriteOptions = {}
): Promise<void> {
    await enqueueStructuredEntityWrite({
        scope,
        registration: PROP_WRITE_REGISTRATION,
        entityId: propId,
        kind: 'deleteEntity',
        payload: { id: propId },
        actorId: options.actorId,
    });
}
